import { jsx as _jsx } from "react/jsx-runtime";
import { transient } from '@lichtblick/styled';
import { forwardRef } from 'react';
import { StyledText } from './Text.styles';
export const Text = /*#__PURE__*/ forwardRef(({ align, hasSpacing, isBold, isItalic, renderAs, size, ...props }, ref)=>/*#__PURE__*/ _jsx(StyledText, {
        ...props,
        ...transient({
            align,
            hasSpacing,
            isBold,
            isItalic,
            size
        }),
        as: renderAs,
        ref: ref
    }));

//# sourceMappingURL=Text.js.map